import { createSignal, onMount, Show } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { finishLogin } from "../auth/oidc";
import { setAuthState } from "../auth/store";

export function Callback() {
  const nav = useNavigate();
  const [err, setErr] = createSignal<string | null>(null);

  onMount(async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const state = await finishLogin(params);
      setAuthState(state);
      nav("/", { replace: true });
    } catch (e) {
      setErr(String(e));
    }
  });

  return (
    <div class="grid h-full place-items-center p-10 text-sm text-ink-700">
      <Show when={err()} fallback={<span>Finishing sign-in…</span>}>
        <div class="max-w-md rounded border border-danger/50 bg-danger/10 p-3 text-danger">
          Sign-in failed — {err()}
        </div>
      </Show>
    </div>
  );
}
